import axios from "axios";
import { apiAddress } from "../../config/server";
import { AppointmentQueryPayload } from "../../types/reports/appointmentQuery";
import { AppointmentReportResponse } from "../../types/reports/appointmentReport";
import { ApiBase } from "./baseApi";

const BASE_URL = `${apiAddress}/api/reports/appointments`;
const PERSONS_URL = `${apiAddress}/api/reports/persons`;

export interface PersonCountFilters {
  associationId: string;
  tenures?: string[];
  role?: string;
  roleGrades?: (number | string)[];
  personIds?: string[];
}

export default class AppointmentReportingApi extends ApiBase {
  static async query(payload: AppointmentQueryPayload): Promise<AppointmentReportResponse> {
    const response = await this.post<AppointmentReportResponse>(`${BASE_URL}/query`, payload);
    return response.data.data;
  }

  static async countPersons(payload: AppointmentQueryPayload): Promise<number> {
    const response = await this.post<{ count: number }>(`${BASE_URL}/count-persons`, payload);
    return response.data.data.count;
  }

  static async countPersonsWithFilters(filters: PersonCountFilters): Promise<number> {
    const response = await this.post<{ count: number }>(`${PERSONS_URL}/count`, filters);
    return response.data.data.count;
  }

  static async exportCsv(payload: AppointmentQueryPayload): Promise<Blob> {
    const response = await axios.post(`${BASE_URL}/export`, payload, {
      responseType: "blob",
    });
    return response.data;
  }
}

